<div class="sfcid-dialog-title" mat-dialog-title>
  <span>
    <mat-icon class="q9-logo-color icon green-icon" svgIcon="task-alt"></mat-icon>
    <span>{{ 'SF_CONNECTIONS.ORG_CONNECTION_TITLE' | translate }}</span>
  </span>
  <q9-dialog-close-button *ngIf="data.isReconnect" (click)="acknowledge()"></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <q9-section>
    <div content>
      <div class="sfcid-banner sfcid-info-banner">
        <mat-icon class="q9-logo-color icon green-icon" svgIcon="schedule"></mat-icon>
        <div>
          <div class="next-steps-title">
            {{ 'SF_CONNECTIONS.NEXT_STEPS_SFCID_T' | translate }}
          </div>
          <div class="next-steps-description">
            {{ 'SF_CONNECTIONS.NEXT_STEPS_SFCID_D' | translate }}
          </div>
        </div>
      </div>

      <q9ma-connection-details-list [items]="detailsItems"></q9ma-connection-details-list>
    </div>
  </q9-section>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button *ngIf="data.isReconnect" [color]="data.color" (click)="acknowledge()">
    {{ 'REFERENCE_MODELS.CREATE_CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="completeSetup()" [color]="data.color">
    {{ 'SF_CONNECTIONS.COMPLETE_SETUP' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
